import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/index',
  },
  {
    path: '/appdownload',
    name: 'appdownload',
    component: () => import('@/views/appDownload/index.vue'),
  },
  // 电商工厂线索宝
  {
    path: '/fasuzaixian',
    name: 'fasuzaixian',
    component: () => import('@/views/DSGCHtml/DsFactory/index'),
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('@/views/DSGCHtml/fasuzaixian/index'),
      },
      //用户列表
      {
        path: '/user',
        name: 'user',
        component: () => import('@/views/DSGCHtml/fasuzaixian/user/userLIst'),
      },
      //案例列表
      {
        path: '/case',
        name: 'case',
        component: () => import('@/views/DSGCHtml/fasuzaixian/entrust/case'),
      },
      //律师列表
      {
        path: '/attorney',
        name: 'attorney',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/attorney/attorney'),
      },
      // 律师审核列表
      {
        path: '/attorneyAuto',
        name: 'attorneyAuto',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/attorney/attorneyAuto'),
      },
      //委托列表
      {
        path: '/entrust',
        name: 'entrust',
        component: () => import('@/views/DSGCHtml/fasuzaixian/entrust/entrust'),
      },
      //咨询列表
      {
        path: '/consult',
        name: 'consult',
        component: () => import('@/views/DSGCHtml/fasuzaixian/entrust/consult'),
      },
      {
        path: '/writ',
        name: 'writ',
        component: () => import('@/views/DSGCHtml/fasuzaixian/entrust/writ'),
      },
      {
        path: '/serve',
        name: 'serve',
        component: () => import('@/views/DSGCHtml/fasuzaixian/system/serve'),
      },
      {
        path: '/contract',
        name: 'contract',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/contract/contract'),
      },
      {
        path: '/contractAuto',
        name: 'contractAuto',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/contract/contractAuto'),
      },
      {
        path: '/category',
        name: 'category',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/contract/category'),
      },
      {
        path: '/industry',
        name: 'industry',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/contract/industry'),
      },
      {
        path: '/agreement',
        name: 'agreement',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/system/agreement'),
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: () => import('@/views/DSGCHtml/fasuzaixian/system/feedback'),
      },
      {
        path: '/businessManagement',
        name: 'businessManagement',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/system/businessManagement'),
      },
      {
        path: '/tags',
        name: 'tags',
        component: () => import('@/views/DSGCHtml/fasuzaixian/contract/tags'),
      },
      {
        path: '/complaint',
        name: 'complaint',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/system/complaint'),
      },
      {
        path: '/prosecute',
        name: 'prosecute',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/prosecute/prosecute'),
      },
      {
        path: '/withdrawallist',
        name: 'withdrawallist',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/finance/withdrawallist'),
      },
      {
        path: '/financial',
        name: 'financial',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/finance/financial'),
      },
      {
        path: '/articleList',
        name: 'articleList',
        component: () =>
          import('@/views/DSGCHtml/fasuzaixian/article/articleList'),
      },
    ],
  },
]
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

const router = new Router({
  mode: 'history',
  routes,
})

export default router
